import { defineRoute } from "src/routing/defineRoute";

/**
 * Path + typed URL builder pairs for `/libraries/plan-packages/*` (v2).
 *
 * Kept separate from the route tree so `RouteUrls.ts` and pages can import paths without a cycle
 * through page `Component` imports.
 *
 * Full absolute strings (RR6 requires a child's path to start with its parent's).
 */
export const planPackageCreateRoute = defineRoute("/libraries/plan-packages/add");
export const planPackageRoute = defineRoute("/libraries/plan-packages/:planPackageId/:planPackageVersionId");
export const planPackageOverviewRoute = defineRoute(
  "/libraries/plan-packages/:planPackageId/:planPackageVersionId/overview",
);
export const planPackageElevationsRoute = defineRoute(
  "/libraries/plan-packages/:planPackageId/:planPackageVersionId/elevations",
);
export const planPackageProgramDataRoute = defineRoute(
  "/libraries/plan-packages/:planPackageId/:planPackageVersionId/program-data",
);
export const planPackageLocationsRoute = defineRoute(
  "/libraries/plan-packages/:planPackageId/:planPackageVersionId/locations",
);
export const planPackageOptionsRoute = defineRoute(
  "/libraries/plan-packages/:planPackageId/:planPackageVersionId/options",
);
export const planPackageTakeoffsRoute = defineRoute(
  "/libraries/plan-packages/:planPackageId/:planPackageVersionId/takeoffs",
);
export const planPackageCheckoutRoute = defineRoute(
  "/libraries/plan-packages/:planPackageId/:planPackageVersionId/checkout",
);
export const planPackageDocumentsRoute = defineRoute(
  "/libraries/plan-packages/:planPackageId/:planPackageVersionId/documents",
);
export const planPackageVersionHistoryRoute = defineRoute(
  "/libraries/plan-packages/:planPackageId/:planPackageVersionId/history",
);
